export const PAGE_LIMIT = 20;

export const calculatePaginatedRows = <T>(page: number, list: T[]): T[] => {
    const skip = (page - 1) * PAGE_LIMIT;
    return list.slice(skip, page * PAGE_LIMIT);
};